import CrudModel from './CrudModel';
import { asyncFn } from './utils';
import download from './download';

const recursive = (object, array) => {
  let tempArray;
  if (object.parentRelation) {
    tempArray = recursive(object.parentRelation, [...array, object.id]);
  } else {
    tempArray = [...array, object.id];
  }
  return tempArray;
};

class ProductModel extends CrudModel {
  constructor(data = {}) {
    super(data);
    this.quantityModel = {
      request: this.buildActionName('request', 'update', 'quantity'),
      response: this.buildActionName('response', 'update', 'quantity'),
      error: this.buildActionName('error', 'update', 'quantity'),
    };
    this.exportExcelModel = {
      request: this.buildActionName('request', 'export', 'excel'),
      response: this.buildActionName('response', 'export', 'excel'),
      error: this.buildActionName('error', 'export', 'excel'),
    };
    this.initialState.excel = {
      error: false,
      errorMessage: '',
      isLoading: false,
    };
  }

  updateQuantity = ({ body }) => asyncFn({
    body, url: `${this.url}/update_quantity`, model: this.quantityModel,
  })

  upload = ({ body }) => asyncFn({
    body, url: `${this.url}/upload_multi`, model: this.model.upload,
  })

  // exportExcel = () => asyncFn({
  //   url: '/rest/store_product/export', model: this.exportExcelModel,
  // })

  exportExcel = () => (async (dispatch) => {
    dispatch({ type: 'REQUEST_EXPORT_EXCEL' });
    fetch('/rest/store_product/export')
      .then(resp => resp.blob())
      .then((blob) => {
        dispatch({ type: 'RESPONSE_EXPORT_EXCEL' });
        download(blob);
      })
      .catch((e) => {
        dispatch({ type: 'ERROR_EXPORT_EXCEL' });
        console.log(e);
      });
  })

  reducer = (state = this.initialState, action) => {
    switch (action.type) {
      case 'FORM_RESET':
        return {
          ...state,
          current: {
            error: false,
            errorMessage: '',
            isLoading: false,
            data: {},
          },
        };
      case this.model.all.request:
        return {
          ...state,
          all: this.requestCase(state.all, action),
        };
      case this.model.all.error:
        return {
          ...state,
          all: this.errorCase(state.all, action),
        };
      case this.model.all.response:
        return {
          ...state,
          all: {
            ...state.all,
            isLoading: false,
            data: action.payload.list,
            total: action.payload.total,
          },
        };
      case this.model.get.request:
        return {
          ...state,
          current: this.requestCase(state.current, action),
        };
      case this.model.get.error:
        return {
          ...state,
          current: this.errorCase(state.current, action),
        };
      case this.model.get.response:
        let cleanedData = {};
        let prefixedRelationId = recursive(action.payload.relation, []).reverse().join(' / ');
        cleanedData = action.payload;
        cleanedData.relation_id = prefixedRelationId;

        // cleanedData.productImages.forEach((element) => {
        //   element.key = element.id;
        // });

        // cleanedData.productImages = JSON.stringify(cleanedData.productImages);

        cleanedData.productImages.forEach((entry, key) => {
          cleanedData.productImages[key] = {
            ...entry,
            uid: `rc-animate-uid-${entry.id}`,
            status: 'done',
            // url: `${s3Host}${entry.dump_link}`,
            // thumbUrl: `${s3Host}${entry.link}`,
          };
        });

        return {
          ...state,
          current: {
            ...state.current,
            isLoading: false,
            data: cleanedData,
          },
        };
      case this.model.create.request:
        return {
          ...state,
          current: this.requestCase(state.current, action),
        };
      case this.model.create.error:
        return {
          ...state,
          current: this.errorCase(state.current, action),
        };
      case this.model.create.response:
        return {
          ...state,
          current: {
            ...state.current,
            isLoading: false,
            data: action.payload,
          },
        };
      case this.model.update.request:
        return {
          ...state,
          current: this.requestCase(state.current, action),
        };
      case this.model.update.error:
        return {
          ...state,
          current: this.errorCase(state.current, action),
        };
      case this.model.update.response:
        return {
          ...state,
          current: {
            ...state.current,
            isLoading: false,
            data: action.payload,
          },
        };
      case this.model.delete.request:
        return {
          ...state,
          current: this.requestCase(state.current, action),
        };
      case this.model.delete.error:
        return {
          ...state,
          current: this.errorCase(state.current, action),
        };
      case this.model.delete.response:
        return {
          ...state,
          current: {
            ...state.current,
            isLoading: false,
            data: {},
          },
        };
      case this.quantityModel.request:
        return {
          ...state,
          all: this.requestCase(state.all, action),
        };
      case this.quantityModel.error:
        return {
          ...state,
          all: this.errorCase(state.all, action),
        };
      case this.quantityModel.response:
        return state;
      case 'REQUEST_EXPORT_EXCEL':
        return {
          ...state,
          excel: {
            ...state.excel,
            isLoading: true,
          },
        };
      case 'RESPONSE_EXPORT_EXCEL':
        return {
          ...state,
          excel: {
            ...state.excel,
            isLoading: false,
          },
        };
      case 'ERROR_EXPORT_EXCEL':
        return {
          ...state,
          excel: {
            ...state.excel,
            isLoading: false,
          },
        };
      default:
        return state;
    }
  }
}

export default ProductModel;




// WEBPACK FOOTER //
// ./src/models/ProductModel.js